export const HUB_HEADER_PORTAL_ATTR = "data-hub-header-portal-root";
export const PROFILE_HEADER_PORTAL_ATTR = "data-profile-header-portal-root";

export function queryHubHeaderPortalRoot(host: HTMLElement): HTMLElement | null {
  return host.querySelector(`[${HUB_HEADER_PORTAL_ATTR}]`) as HTMLElement | null;
}

export function queryProfileHeaderPortalRoot(host: HTMLElement): HTMLElement | null {
  return host.querySelector(`[${PROFILE_HEADER_PORTAL_ATTR}]`) as HTMLElement | null;
}
